import { IConfig } from '@cian/config/shared';

import { REMEMBER_ACCOUNTS_EXPERIMENT } from '../../constants/experiments';
import { IApplicationState } from '../../types/redux';
import { isExperimentActive } from '../../utils/experiments';

interface IDependencies {
  config: IConfig;
}

export const selectIsRememberAccountsFlow =
  ({ config }: IDependencies) =>
  ({ experiments }: IApplicationState): boolean => {
    const isRememberAccountsFlowEnabled = config.get<boolean>('auth.rememberAccountsFlow.enabled') || false;

    return isRememberAccountsFlowEnabled && isExperimentActive(experiments, REMEMBER_ACCOUNTS_EXPERIMENT, 'B');
  };
